import {
  AfterContentInit,
  Component,
  ContentChildren,
  forwardRef,
  OnDestroy,
  QueryList,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

import { CdwRadioButtonComponent } from '../cdw-radio-button/cdw-radio-button.component';

@Component({
  selector: 'lib-cdw-radio-group',
  templateUrl: './cdw-radio-group.component.html',
  styleUrls: ['./cdw-radio-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CdwRadioGroupComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CdwRadioGroupComponent
  implements ControlValueAccessor, AfterContentInit, OnDestroy
{
  private onDestroy$: Subject<void> = new Subject<void>();

  value: unknown;

  @ContentChildren(CdwRadioButtonComponent)
  radioButtons!: QueryList<CdwRadioButtonComponent>;

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  ngAfterContentInit() {
    this.checkSelectedButton(this.value);

    this.radioButtons.forEach((radioButton) => {
      radioButton.valueChange
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((val) => {
          this.onTouched();
          this.value = val;
          this.onChange(val);
          this.checkSelectedButton(this.value);
        });
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (value: unknown) => {
    // Placeholder for ControlValueAccessor - overridden by registerOnChange
  };

  onTouched = () => {
    // Placeholder for ControlValueAccessor - overridden by registerOnTouched
  };

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: unknown) {
    this.value = value;
    if (this.radioButtons) {
      this.checkSelectedButton(value);
    }
  }

  checkSelectedButton(value: unknown) {
    const selectedRadioButton = this.radioButtons.find(
      (radiobutton) => radiobutton.value === value
    );
    this.radioButtons.forEach((radiobutton) => {
      // eslint-disable-next-line no-param-reassign
      radiobutton.checked = false;
    });
    if (selectedRadioButton) {
      selectedRadioButton.checked = true;
    }
  }
}
